export const formatDateString = (date: string): string => {
    const dateWithoutTime = date.split('T')[0]
    const dayMonthYear = dateWithoutTime.split('-').reverse().join('/')
    return dayMonthYear
}